import { ADD_PROJECT, ADD_PROJECT_LINK, ADD_RELEASE_ID, ADD_SIMPLE_USER_LIST, CLEAR_RELEASE, CLEAR_PROJECT } from './projectTypes';

const initialState = {
    currentProject: null,
    projectLink: [],
    simpleUsers: {},
    releaseId: 0,
    loading: false
};

export default function projectReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_PROJECT:
            return { ...state, currentProject: action.payload };
        case ADD_PROJECT_LINK:
            return { ...state, projectLink: action.payload };
        case ADD_RELEASE_ID:
            return { ...state, releaseId: action.payload };
        case ADD_SIMPLE_USER_LIST:
            return { ...state, simpleUsers: action.payload };
        case CLEAR_RELEASE:
            return { ...state, releaseId: 0 };
        case CLEAR_PROJECT:
            return initialState;
        default:
            return state;
    }
}
